import React from "react";
import { Link } from "react-router-dom";
import logo from "../Assets/images/logo-2.jpeg";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { TfiWorld } from "react-icons/tfi";

const footerData = [
  {
    heading: "For Business Users",
    links: [
      { name: "How to hire ERP Consultant", to: "/how_to_hire_erp_consultant" },
      { name: "How JustERPs work?", to: "/how/erp/works" },
      { name: "FAQs", to: "/faq" },
    ],
  },
  {
    heading: "For ERP Freelancers",
    links: [
      { name: "Join as Freelancer ERP Consultant", to: "/join/as/consultant" },
      { name: "JustERPs ProjectTeams", to: "/erp/team" },
    ],
  },
  {
    heading: "Categories",
    links: [
      { name: "ERP Consultant", to: "/join" },
      { name: "Data Migration", to: "/join" },
      { name: "Business Intelligence (BI)", to: "/join" },
      { name: "Change Management", to: "/join" },
      { name: "End-User Trainers", to: "/join" },
      { name: "Reporting", to: "/join" },
      { name: "GRC", to: "/join" },
      { name: "BA (Business Analyst)", to: "/join" },
      { name: "Data Entry", to: "/join" },
      { name: "Technical Consultant", to: "/join" },
      { name: "Functional Consultant", to: "/join" },
      { name: "Techno-Functional Consultant", to: "/join" },
      { name: "Project Manager", to: "/join" },
      { name: "Team Lead", to: "/join" },
      { name: "View full list of all categories", to: "/join" },
    ],
  },
  {
    heading: "About JustERPs",
    links: [
      { name: "JustERPs", to: "/justerps" },
      { name: "Customer Support", to: "/customer/services" },
      { name: "Privacy Policy & Terms of Services", to: "/terms/services" },
      { name: "Social Responsibility", to: "/social/responsibility" },
      { name: "Refer to a Consultant Bonus", to: "/referral/bonus" },
      { name: "Personal Data Protection", to: "/personal/data/protection" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 text-sm text-gray-600">
      <div className="max-w-7xl mx-auto px-4 py-10 md:pt-14">
        {/* Links Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {footerData.map((section, index) => (
            <div key={index}>
              <h4 className="text-gray-800 font-semibold mb-4">
                {section.heading}
              </h4>
              <ul className="space-y-2">
                {section.links.map((link, i) => (
                  <li key={i}>
                    <Link to={link.to} className="hover:underline">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="mt-10 border-t border-gray-200 pt-6">
          <p className="text-xs leading-relaxed text-gray-500 text-center">
  <strong>Note:</strong> All ERPs names, logos, and/or any materials
  featured on this website are for educational purposes only.
</p>


        </div>

        {/* Bottom Bar */}
        <div className="mt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-wrap gap-3 items-center">
            <img
              src={logo}
              className="w-48 rounded-lg"
              alt="JustERPs Logo"
            />
            <p className="text-xs text-black leading-relaxed">
  © {new Date().getFullYear()} JustERPs International Ltd.
</p>

          </div>

          {/* Social Media Icons (BLACK) */}
          <div className="flex space-x-6 text-md text-black items-center">
            <a
              href="https://www.facebook.com/profile.php?id=61586894497487"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com/justerps"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com/justerps_/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/justerps"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>

            <div className="flex items-center gap-2 font-semibold cursor-pointer">
              <TfiWorld />
              <span>English</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
